/**
 * English for the phone and the narrow and wide screens (card У9): the
 * bottom bar, the phone header and what a screen says only at phone width.
 * Spread into `en`, so the keys are part of `TKey` and `ru.adaptive.ts` must
 * cover every one of them.
 */
export const enAdaptive = {
  "adapt.tab.report": "Report",
  "adapt.tab.more": "More",
  "adapt.back": "Back to {place}",
  "adapt.approve": "approve {pct}",
  "adapt.today.caption": "Profit today, to {at} · {tz}",
  "adapt.today.vsYesterday": "vs yesterday",
  "adapt.sort": "Sort",
  "adapt.sortBy.profit": "by profit",
  "adapt.sortBy.roi": "by ROI",
  "adapt.sortBy.clicks": "by clicks",
  "adapt.sortBy.leads": "by leads",
  "adapt.sortBy.cost": "by spend",
  "adapt.sortBy.name": "by name",
  "adapt.path.lpCtr": "{pct} LP CTR",
  "adapt.path.cr": "CR {cr}",
  "adapt.report.total": "Total",
  "adapt.report.starts": "Quick reports",
  "adapt.report.start.country": "By country",
  "adapt.report.start.campaign": "By campaign",
  "adapt.report.start.hour": "By hour",
  "adapt.report.sub": "{clicks} cl · {leads} {word}",
};
